import {ActionTypes} from "./type";

export const newAction = (data) => async (dispatch) => {
    dispatch({
        type: ActionTypes.SET_ACTION_ID,
        payload: data
    });
};

